import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Row, Skeleton } from 'antd';
import { Title } from '@/components/Typography';
import { RPNScore, RPNTopic, Score, Topic } from './styles';

interface ScoresProps {
	isLoading?: boolean;
	rpn: number;
	severity: number;
	exposure: number;
	vulnerability: number;
}

export function Scores({
	isLoading = false,
	rpn,
	severity,
	exposure,
	vulnerability
}: Readonly<ScoresProps>): JSX.Element {
	return (
		<Col span={7}>
			<Row>
				<Col span={24}>
					<Title level={5}>Result</Title>
				</Col>
			</Row>
			{isLoading ? (
				<Skeleton active />
			) : (
				<Row style={{ marginTop: '1rem' }}>
					<Col span={23} offset={1}>
						<Row gutter={[0, 12]}>
							<Col span={16}>
								<Row justify="space-between">
									<Col>
										<Topic>{I18n.get('Exposure')}:</Topic>
									</Col>
									<Col>
										<Score>{exposure}</Score>
									</Col>
								</Row>
							</Col>
							<Col span={16}>
								<Row justify="space-between">
									<Col>
										<Topic>{I18n.get('Severity')}:</Topic>
									</Col>
									<Col>
										<Score>{severity}</Score>
									</Col>
								</Row>
							</Col>
							<Col span={16}>
								<Row justify="space-between">
									<Col>
										<Topic>{I18n.get('Vulnerability')}:</Topic>
									</Col>
									<Col>
										<Score>{vulnerability}</Score>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row style={{ marginTop: '2rem' }}>
							<Col span={20}>
								<Row justify="space-between" align="middle">
									<Col span={16}>
										<RPNTopic>{I18n.get('Risk Priority Number (RPN)')}:</RPNTopic>
									</Col>
									<Col span={3}>
										<RPNScore>{rpn}</RPNScore>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
				</Row>
			)}
		</Col>
	);
}
